import { Component } from '@angular/core';
import {ThemeService} from '../../providers/theme-service';
import {VoltioLandingPage} from '../index';
import {NavController} from 'ionic-angular';

@Component({
  selector: 'page-themes',
  templateUrl: 'themes.html'
})
export class ThemesPage {

  // we know that the selection is going to be a string,
  // since it matches a class attribute
  selected: String;
  // typing the choices for the select interface, like a boss
  availableThemes: {className: string, prettyName: string}[];

  constructor(public navCtrl: NavController, private _theme: ThemeService) {

    //TODO: put in your app you'll want to keep this in a database somewhere.
    // now we're setting the selected property asynchronously, based
    // on the behavior of our observable theme in SettingsService
    this._theme.getTheme().subscribe(val => this.selected = val);
    // similarly, as promised, we've moved availableThemes to SettingsService,
    // and therefore need to call that property here
    this.availableThemes = this._theme.availableThemes;

  }

  setTheme(e) {
    this._theme.setTheme(e);

    console.log('Theme set and moving to landing page')
    this.navCtrl.push(VoltioLandingPage); //TODO: This is cheating /move to last page?

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ThemesPage');
  }
}



// WEBPACK FOOTER //
// ./src/pages/themes/themes.ts